import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Plus, Check, Trash2, Folder } from "lucide-react";
import { toast } from "../hooks/use-toast";

export default function Planos() {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", description: "" });

  const load = async () => { const r = await api.get("/plans"); setItems(r.data); };
  useEffect(() => { load(); }, []);

  const save = async () => {
    if (!form.name) { toast({ title: "Informe o nome do plano" }); return; }
    await api.post("/plans", form);
    setOpen(false);
    setForm({ name: "", description: "" });
    load();
  };
  const activate = async (id) => { await api.put(`/plans/${id}/activate`); load(); };
  const del = async (id) => { await api.delete(`/plans/${id}`); load(); };

  return (
    <div className="space-y-6 max-w-[1400px]">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-3xl font-extrabold">Planos</h1>
        <Button onClick={() => setOpen(true)} className="bg-tiffany-500 hover:bg-tiffany-600 text-white">
          <Plus size={16} className="mr-1" /> Novo Plano
        </Button>
      </div>

      {items.length === 0 ? (
        <div className="rounded-2xl border border-dashed border-border p-12 text-center">
          <Folder size={40} className="mx-auto text-muted-foreground mb-3" />
          <p className="text-muted-foreground mb-4">Organize seus estudos criando planos por concurso.</p>
          <Button onClick={() => setOpen(true)} className="bg-tiffany-500 hover:bg-tiffany-600 text-white">Criar primeiro plano</Button>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((p) => (
            <div key={p.id} className={`rounded-2xl bg-card border p-5 ${p.active ? "border-tiffany-500 ring-2 ring-tiffany-200 dark:ring-tiffany-900" : "border-border"}`}>
              <div className="flex justify-between items-start mb-3">
                <div>
                  <div className="flex items-center gap-2">
                    <h3 className="font-display font-bold text-lg">{p.name}</h3>
                    {p.active && <span className="text-xs bg-tiffany-500 text-white px-2 py-0.5 rounded-full">Ativo</span>}
                  </div>
                  {p.description && <p className="text-sm text-muted-foreground mt-1">{p.description}</p>}
                </div>
                <button onClick={() => del(p.id)} className="text-red-500 hover:bg-red-50 p-1.5 rounded"><Trash2 size={14} /></button>
              </div>
              {!p.active && (
                <Button size="sm" onClick={() => activate(p.id)} variant="outline" className="w-full mt-2">
                  <Check size={14} className="mr-1" /> Ativar Plano
                </Button>
              )}
            </div>
          ))}
        </div>
      )}

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent>
          <DialogHeader><DialogTitle>Novo Plano</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <Input placeholder="Nome (ex: PC-DF, PRF, TJ-SP)" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
            <Textarea placeholder="Descrição (opcional)" rows={3} value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} />
          </div>
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button>
            <Button onClick={save} className="bg-tiffany-500 hover:bg-tiffany-600 text-white">Criar</Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
